
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2154',
  depVersions: {
  "customer-portal-app": "static-1.2154",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.461",
  "data-fetching-client": "static-1.9633",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25226",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5552",
  "hs-test-utils": "static-1.7975",
  "hub-http": "static-1.6180",
  "hub-http-shared-msw-handlers": "static-1.9856",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18099",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11420",
  "I18n": "static-7.1613",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6428",
  "payment-link-components": "static-1.23401",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6965",
  "quartz-core": "static-1.6184",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10169",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5309",
  "rich-text-lib": "static-1.19752",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17924",
  "ui-components-test-utils": "static-1.5558",
  "UIComponents": "static-3.8367",
  "foundations-assets": "static-1.4815",
  "foundations-components": "static-1.7845",
  "foundations-theming": "static-1.4375",
  "foundations-theming-specialty": "static-1.2091",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.811",
  "quartz-config": "static-1.743",
  "quartz-routing": "static-1.395",
  "quick-fetch": "static-1.3882",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16627",
  "rpc-client-utils": "static-1.4609",
  "sanitize-text": "static-1.8102",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4728",
  "ui-addon-react-router-dom": "static-1.9504",
  "usage-tracker": "static-1.7298",
  "usage-tracker-anonymous": "static-1.5715",
  "usage-tracker-core": "static-1.7148",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3369",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3242",
  "quartz-webpack": "static-1.3189",
  "bend-plugin-quartz-routing": "static-1.43",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7622",
  "frontend-preferences-client": "static-1.7886",
  "laboratory-lib": "static-3.7117",
  "onboarding-scopes": "static-1.6421",
  "ui-addon-opt": "static-4.8332",
  "HeadJS": "static-2.742",
  "hs-test-utils-bend-plugin": "static-1.3086",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.50",
  "ts-schema": "static-1.4044",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7682",
  "cssUtils": "static-1.781",
  "customer-data-ui-utilities": "static-1.9785",
  "HubStyle": "static-2.11728",
  "knowledge-content-types": "static-1.8479",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.640",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9847",
  "ui-addon-i18n": "static-1.11109",
  "ui-business-units-lib": "static-1.9007",
  "ui-shepherd-react": "static-3.10107",
  "video-components-external": "static-1.11110",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4283",
  "commerce-tours-lib": "static-1.6010",
  "customer-data-properties": "static-1.51380",
  "getting-started-shared-tasks": "static-1.18361",
  "growth-onboarding-reliability": "static-1.5040",
  "onboarding-tours": "static-1.16510",
  "reference-resolvers-lite": "static-1.8054",
  "sales-checkout-service-client": "static-1.3598",
  "ui-addon-iframeable": "static-1.9014",
  "user-context": "static-1.5060",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4618",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.516",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.640",
  "quartz-head": "static-1.630",
  "quartz-test": "static-1.640",
  "quartz-tracking": "static-1.344",
  "ui-fonts": "static-1.682",
  "usage-tracker-container": "static-1.7288",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9388",
  "data-token-picker": "static-1.16326",
  "FileManagerLib": "static-1.39130",
  "property-translator": "static-1.5360",
  "atom": "static-1.5031",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5804",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5328",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1141",
  "bend-plugin-foundations-components": "static-1.4114",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.12",
  "trellis-assets": "static-1.1712",
  "bend-plugin-foundations-theming": "static-1.2858",
  "foundations-theming-base": "static-1.3360",
  "stylex": "static-1.32",
  "interframe": "static-3.4720",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5712",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.19",
  "chirp-fetch": "static-1.1844",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4431",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3123",
  "inbound-db-properties-service-client": "static-1.3806",
  "superstore": "static-1.4725",
  "feedback-loader": "static-1.29214",
  "ai-components-ui-library": "static-1.8814",
  "ui-addon-video-player": "static-1.8657",
  "ui-coaching-tips": "static-1.28411",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4579",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2457",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8129",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4607",
  "content-media-composition-data-lib": "static-1.12091",
  "content-media-compositions": "static-2.16098",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4112",
  "magpie-lib": "static-1.5533",
  "magpie-types": "static-1.4993",
  "media-bridge-lib": "static-1.18848",
  "video-data-lib": "static-1.34768",
  "commerce-products-lib": "static-1.9356",
  "crm-message-bus": "static-1.42857",
  "growth-data-modal": "static-1.5355",
  "hubspot-apollo-client": "static-1.4835",
  "onboarding-tours-client": "static-1.4724",
  "calling-global-api": "static-1.64343",
  "calling-internal-common": "static-1.31261",
  "calling-lifecycle-internal": "static-1.65725",
  "calling-lifecycle-messages": "static-1.58019",
  "conditional-properties-service-client": "static-1.3763",
  "crm-links": "static-1.6242",
  "customer-data-objects-ui-components": "static-1.12984",
  "customer-data-properties-shared-msw-handlers": "static-1.9183",
  "customer-data-property-utils": "static-1.8042",
  "external-options-client-types": "static-1.4124",
  "file-manager-components": "static-1.23490",
  "framework-data-schema-resolvers": "static-1.6838",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.107",
  "inbound-db-meta-service-client": "static-1.3556",
  "inbounddb-objects-service-types": "static-1.4189",
  "meetings-icalendar-utils-lib": "static-1.590",
  "multi-currency-client-types": "static-1.3657",
  "object-builder-ui-client": "static-1.48576",
  "pipeline-validation-client-types": "static-1.3931",
  "property-value-citations": "static-1.1994",
  "pulse": "static-1.519",
  "smart-property-lib": "static-1.6690",
  "tiered-pricing": "static-1.1115",
  "ui-addon-form-validation": "static-1.10947",
  "growth-onboarding-confetti": "static-1.3026",
  "growth-onboarding-next-action-utils": "static-1.1773",
  "navigation-components": "static-1.17875",
  "onboarding-tours-utils": "static-1.576",
  "ui-shepherd-tracker": "static-1.7488",
  "ui-universal-auth": "static-1.8922",
  "batch-promise": "static-1.1508",
  "navigation-messaging": "static-1.7202",
  "getting-started-shared-tasks-store": "static-1.17479",
  "hubspotter-http-shared-msw-handlers": "static-1.9854",
  "usage-tracker-session-replay": "static-1.4984",
  "audio-components": "static-1.5847",
  "FileManagerCore": "static-1.38989",
  "FileManagerImages": "static-1.36641",
  "video-components": "static-1.13113",
  "foundations-components-legacy": "static-1.870",
  "purchase-motions-api": "static-1.5807",
  "self-service-api": "static-1.10204",
  "signup-constants": "static-1.18759",
  "signup-ui-url-generator": "static-2.7999",
  "trials-service-types": "static-1.3862",
  "usage-tracker-public": "static-1.7109",
  "chatspot-core": "static-1.21057",
  "ContentUtils": "static-1.68223",
  "copilot-toolkit": "static-1.10992",
  "growth-onboarding-feedback-components": "static-1.6542",
  "reactive-lib": "static-1.680",
  "simple-logging-lib": "static-1.3008",
  "commerce-permissions": "static-1.725",
  "customer-data-tracking": "static-1.6844",
  "products-iframe-lib": "static-1.7789",
  "products-ui-components-shared-msw-handlers": "static-1.10238",
  "onboarding-data-sync-lib": "static-1.1886",
  "hubspot-apollo-cache": "static-1.294",
  "calling-error-reporting": "static-1.31267",
  "shared-worker-versioning": "static-1.10996",
  "calling-usage-tracker": "static-1.6501",
  "voice-sms-access-library": "static-1.794",
  "conversations-skeleton-state": "static-1.7207",
  "location-customization-utils-lib": "static-1.9101",
  "crm-pipelines-api-client-types": "static-1.4108",
  "framework-builder-read-service-client": "static-1.3975",
  "framework-data-schema-quick-fetch": "static-1.6743",
  "persist-promise": "static-1.3665",
  "bend-plugin-pulse": "static-1.22",
  "directed-graph": "static-1.894",
  "event-emitter": "static-1.907",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.121",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9939",
  "fsm": "static-1.3691",
  "policy-lib": "static-1.6732",
  "react-tinymce": "static-1.55106",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10002",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54232",
  "tinymce-plugins": "static-1.57346",
  "tinymce-themes": "static-1.56202",
  "growth-onboarding-next-action-components": "static-1.1801",
  "user-context-client": "static-1.4569",
  "nest": "static-1.186",
  "unified-auth-core-lib": "static-1.717",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4490",
  "video-embed": "static-1.35602",
  "content-icons-ui": "static-1.2215",
  "social-insights-client-types": "static-1.21955",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4770",
  "integrations-lib": "static-1.15964",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4223",
  "InboxConnectUtils": "static-4.14667",
  "calling-orchestration-schema": "static-1.35571",
  "crm-record-cards-service-types": "static-1.3575",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4474",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.2999",
  "tinymce-data": "static-1.40317",
  "ui-addon-sales-email": "static-1.5169",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12357",
  "layout-dnd-utils": "static-1.11332",
  "react-codemirror": "static-1.10582",
  "ui-brand-identity-lib": "static-1.15045",
  "NamespacedHubStyle": "static-2.9028",
  "outpost": "static-1.4146",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13379",
  "integrations-tracking-lib": "static-1.5557",
  "native-integrations-shared-strings": "static-1.7742",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10330",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.436",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68298",
  "layout-data-lib": "static-1.9657",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2971",
  "google-sheets-integration-lib": "static-1.95",
  "microsoft-drive-integration-lib": "static-1.208",
  "advanced-menus-core": "static-1.15056",
  "advanced-menus-lib": "static-1.12007",
  "ExportDialog": "static-6.10352",
  "ui-memberships-settings-lib": "static-1.33915",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15055",
  "simple-menus-lib": "static-1.16572"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2154",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.461",
  "data-fetching-client": "/data-fetching-client/static-1.9633",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25226",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5552",
  "hs-test-utils": "/hs-test-utils/static-1.7975",
  "hub-http": "/hub-http/static-1.6180",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9856",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18099",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11420",
  "I18n": "/I18n/static-7.1613",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6428",
  "payment-link-components": "/payment-link-components/static-1.23401",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6965",
  "quartz-core": "/quartz-core/static-1.6184",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10169",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5309",
  "rich-text-lib": "/rich-text-lib/static-1.19752",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17924",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5558",
  "UIComponents": "/UIComponents/static-3.8367",
  "foundations-assets": "/foundations-assets/static-1.4815",
  "foundations-components": "/foundations-components/static-1.7845",
  "foundations-theming": "/foundations-theming/static-1.4375",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2091",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.811",
  "quartz-config": "/quartz-config/static-1.743",
  "quartz-routing": "/quartz-routing/static-1.395",
  "quick-fetch": "/quick-fetch/static-1.3882",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16627",
  "rpc-client-utils": "/rpc-client-utils/static-1.4609",
  "sanitize-text": "/sanitize-text/static-1.8102",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4728",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9504",
  "usage-tracker": "/usage-tracker/static-1.7298",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5715",
  "usage-tracker-core": "/usage-tracker-core/static-1.7148",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3369",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3242",
  "quartz-webpack": "/quartz-webpack/static-1.3189",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.43",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7622",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7886",
  "laboratory-lib": "/laboratory-lib/static-3.7117",
  "onboarding-scopes": "/onboarding-scopes/static-1.6421",
  "ui-addon-opt": "/ui-addon-opt/static-4.8332",
  "HeadJS": "/HeadJS/static-2.742",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3086",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.50",
  "ts-schema": "/ts-schema/static-1.4044",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7682",
  "cssUtils": "/cssUtils/static-1.781",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9785",
  "HubStyle": "/HubStyle/static-2.11728",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.640",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9847",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11109",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9007",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10107",
  "video-components-external": "/video-components-external/static-1.11110",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4283",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6010",
  "customer-data-properties": "/customer-data-properties/static-1.51380",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18361",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5040",
  "onboarding-tours": "/onboarding-tours/static-1.16510",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8054",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3598",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9014",
  "user-context": "/user-context/static-1.5060",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4618",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.516",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.640",
  "quartz-head": "/quartz-head/static-1.630",
  "quartz-test": "/quartz-test/static-1.640",
  "quartz-tracking": "/quartz-tracking/static-1.344",
  "ui-fonts": "/ui-fonts/static-1.682",
  "usage-tracker-container": "/usage-tracker-container/static-1.7288",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9388",
  "data-token-picker": "/data-token-picker/static-1.16326",
  "FileManagerLib": "/FileManagerLib/static-1.39130",
  "property-translator": "/property-translator/static-1.5360",
  "atom": "/atom/static-1.5031",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5804",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5328",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1141",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4114",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.12",
  "trellis-assets": "/trellis-assets/static-1.1712",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2858",
  "foundations-theming-base": "/foundations-theming-base/static-1.3360",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4720",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5712",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.19",
  "chirp-fetch": "/chirp-fetch/static-1.1844",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4431",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3806",
  "superstore": "/superstore/static-1.4725",
  "feedback-loader": "/feedback-loader/static-1.29214",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8814",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8657",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28411",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4579",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2457",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8129",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4607",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12091",
  "content-media-compositions": "/content-media-compositions/static-2.16098",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4112",
  "magpie-lib": "/magpie-lib/static-1.5533",
  "magpie-types": "/magpie-types/static-1.4993",
  "media-bridge-lib": "/media-bridge-lib/static-1.18848",
  "video-data-lib": "/video-data-lib/static-1.34768",
  "commerce-products-lib": "/commerce-products-lib/static-1.9356",
  "crm-message-bus": "/crm-message-bus/static-1.42857",
  "growth-data-modal": "/growth-data-modal/static-1.5355",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4835",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4724",
  "calling-global-api": "/calling-global-api/static-1.64343",
  "calling-internal-common": "/calling-internal-common/static-1.31261",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65725",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58019",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3763",
  "crm-links": "/crm-links/static-1.6242",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12984",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9183",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8042",
  "external-options-client-types": "/external-options-client-types/static-1.4124",
  "file-manager-components": "/file-manager-components/static-1.23490",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6838",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.107",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3556",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4189",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.590",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3657",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48576",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3931",
  "property-value-citations": "/property-value-citations/static-1.1994",
  "pulse": "/pulse/static-1.519",
  "smart-property-lib": "/smart-property-lib/static-1.6690",
  "tiered-pricing": "/tiered-pricing/static-1.1115",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10947",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3026",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1773",
  "navigation-components": "/navigation-components/static-1.17875",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.576",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7488",
  "ui-universal-auth": "/ui-universal-auth/static-1.8922",
  "batch-promise": "/batch-promise/static-1.1508",
  "navigation-messaging": "/navigation-messaging/static-1.7202",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17479",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9854",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4984",
  "audio-components": "/audio-components/static-1.5847",
  "FileManagerCore": "/FileManagerCore/static-1.38989",
  "FileManagerImages": "/FileManagerImages/static-1.36641",
  "video-components": "/video-components/static-1.13113",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.870",
  "purchase-motions-api": "/purchase-motions-api/static-1.5807",
  "self-service-api": "/self-service-api/static-1.10204",
  "signup-constants": "/signup-constants/static-1.18759",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7999",
  "trials-service-types": "/trials-service-types/static-1.3862",
  "usage-tracker-public": "/usage-tracker-public/static-1.7109",
  "chatspot-core": "/chatspot-core/static-1.21057",
  "ContentUtils": "/ContentUtils/static-1.68223",
  "copilot-toolkit": "/copilot-toolkit/static-1.10992",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6542",
  "reactive-lib": "/reactive-lib/static-1.680",
  "simple-logging-lib": "/simple-logging-lib/static-1.3008",
  "commerce-permissions": "/commerce-permissions/static-1.725",
  "customer-data-tracking": "/customer-data-tracking/static-1.6844",
  "products-iframe-lib": "/products-iframe-lib/static-1.7789",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10238",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1886",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.294",
  "calling-error-reporting": "/calling-error-reporting/static-1.31267",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10996",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6501",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.794",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7207",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9101",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4108",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3975",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6743",
  "persist-promise": "/persist-promise/static-1.3665",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.22",
  "directed-graph": "/directed-graph/static-1.894",
  "event-emitter": "/event-emitter/static-1.907",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.121",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9939",
  "fsm": "/fsm/static-1.3691",
  "policy-lib": "/policy-lib/static-1.6732",
  "react-tinymce": "/react-tinymce/static-1.55106",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10002",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54232",
  "tinymce-plugins": "/tinymce-plugins/static-1.57346",
  "tinymce-themes": "/tinymce-themes/static-1.56202",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1801",
  "user-context-client": "/user-context-client/static-1.4569",
  "nest": "/nest/static-1.186",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.717",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4490",
  "video-embed": "/video-embed/static-1.35602",
  "content-icons-ui": "/content-icons-ui/static-1.2215",
  "social-insights-client-types": "/social-insights-client-types/static-1.21955",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4770",
  "integrations-lib": "/integrations-lib/static-1.15964",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4223",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14667",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35571",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3575",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4474",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.2999",
  "tinymce-data": "/tinymce-data/static-1.40317",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5169",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12357",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11332",
  "react-codemirror": "/react-codemirror/static-1.10582",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15045",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9028",
  "outpost": "/outpost/static-1.4146",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13379",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5557",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7742",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10330",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.436",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68298",
  "layout-data-lib": "/layout-data-lib/static-1.9657",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2971",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.95",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.208",
  "advanced-menus-core": "/advanced-menus-core/static-1.15056",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12007",
  "ExportDialog": "/ExportDialog/static-6.10352",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33915",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15055",
  "simple-menus-lib": "/simple-menus-lib/static-1.16572"
}
};
